import React from "react";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Box, Drawer, Text, Paper, Divider, Group, ActionIcon } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
import { getPropInSubLevelRole, safetyDecodeJWT, safeValue, sqlDateToHumanDate, numberFormatter, masaGaransiUtils__1, masaGaransiUtils__2, garansiFotoByFlag, getObjectParam2, stringDivider } from "../../utils/globalFunctions";
import { canAccessSeeCustomersPhoneNumber } from "../../utils/accessing";

import ModalResponse from "../../components/general/ModalResponse";
import LabelContentInline from "../../components/general/LabelContentInline";
import GaransiFotoComponent from "../trxGaransiStep1/GaransiFotoComponent";

const GaransiHistorySelected = ({
  stateData,
  fnSuccessEdit,
  fnClickPhoto
}) => {

  const mountedRef = React.useRef(true);

  const { URI1 } = useParams();
  const navigate = useNavigate();

  const { loginContext, handleSetLoginContext } = useLoginContext();

  const notificationId = React.useRef({
    errorGetData: 'garansiSelected-1',
    errorSubmitGaransi: 'garansiSelected-6',
  })

  const [data, setData] = React.useState({
    drawer: false,
    dataInitLoading: false,
    data: [],
    dataFlag: 'idle',

    dataSerialNumber: [],

    modalResponse: {
      show: false,
      type: utils.modalResponse.warning,
      hideOnClickOutSide: false,
      content: ''
    }
  });

  React.useEffect(() => {
    return () => {
      mountedRef.current = false;
    }
  }, [])

  const getValueFromItemsByDetilId = ({ stateDataArray, stateDetilId, statePropRes }) => {
    let res = '';

    if (Array.isArray(stateDataArray) && stateDataArray.length > 0) {
      for (let index = 0; index < stateDataArray.length; index++) {
        if (stateDataArray[index].garansiDetilId === stateDetilId) {
          res = stateDataArray[index][statePropRes];
          break;
        }
      }
    }

    return res;
  }

  const setDataData = ({ stateData, stateShouldUpdateSelectedItems = true }) => {
    if (Array.isArray(stateData) && stateData.length > 0) {
      setData(d => ({
        ...d,
        data: stateData[0],
        dataFlag: true,

        dataSerialNumber: stateShouldUpdateSelectedItems ? Object.values(stateData[0].garansi_detil).map(val => ({
          garansiId: val.stock_garansi_id,
          garansiDetilId: val.stock_garansi_detil_id,
          serialNumber: val.stock_serial_number,
          positioning: utils.statusItemGaransi.masuk_stock.value,
          isChecklist: true,
          isDisabled: false
        })) : d.dataSerialNumber
      }))
    } else {
      setData(d => ({
        ...d,
        dataFlag: false,
      }))
    }
  }

  React.useEffect(() => {
    if (URI1) {

      setData(d => ({
        ...d,
        dataInitLoading: true,
        drawer: true,
      }))

      const formDT = new FormData();
      const formDTHeader = { 'Content-Type': 'application/json' }

      formDT.append('json_token', loginContext.syswebapp);
      formDT.append('flag_all', utils.flagAll);
      formDT.append('garansi_id', URI1);
      formDT.append('garansi_item_status', JSON.stringify(utils.statusItemGaransi));

      axios({
        method: 'post',
        url: BE_API_THREE + '/select_history_garansi_by_garansi_id',
        data: formDT,
        headers: formDTHeader,
      }).then((response) => {
        if (!mountedRef.current) return null;

        setData(d => ({ ...d, dataInitLoading: false }));

        if (response.data.flag_status === 'isset') {
          setDataData({
            stateData: response.data.data,
            stateShouldUpdateSelectedItems: true
          });
        }

        if (response.data.flag_status === 'error') {
          notifications.show({
            id: notificationId.current.errorGetData,
            title: utils.notification.warning.caption,
            message: response.data.pesan,
            color: utils.notification.warning.color,
            icon: utils.notification.warning.icon,
            withBorder: true,
            autoClose: true,
          })
        }

        if (response.data.flag_status === 'no-data') {
          navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });

          setData(d => ({ ...d, drawer: false }));

          setData(d => ({
            ...d,
            modalResponse: {
              ...d.modalResponse,
              type: utils.modalResponse.warning,
              hideOnClickOutSide: true,
              content: 'Data tidak ditemukan.',
              show: true
            }
          }))
        }

        if (response.data.flag_status === 'invalid-json-token') {
          handleSetLoginContext(null);
        }

        if (response.data.flag_status === 'user-inactive') {
          handleSetLoginContext(null);
        }
      }).catch(error => {
        if (!mountedRef.current) return null;

        setData(d => ({
          ...d,
          dataInitLoading: false
        }))

        notifications.show({
          id: notificationId.current.errorGetData,
          title: utils.notification.warning.caption,
          message: error.message,
          color: utils.notification.warning.color,
          icon: utils.notification.warning.icon,
          withBorder: true,
          autoClose: true,
        })
      })
    }
  }, [handleSetLoginContext, loginContext, loginContext.syswebapp, navigate, URI1, stateData.stateMenu, stateData.stateSubMenu, stateData.stateTab, stateData.triggerUpdate])

  const closeDrawer = ({ cleanURICustomerId = true }) => {
    if (cleanURICustomerId) {
      navigate(`/${getPropInSubLevelRole(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappsl'), 'slugLink', '')}/${stateData.stateMenu}/${stateData.stateSubMenu}/${stateData.stateTab}`, { replace: true });
    }

    setData(d => ({ ...d, drawer: false }));
  }

  return (
    <React.Fragment>
      <Drawer
        opened={data.drawer}
        onClose={() => closeDrawer({ cleanURICustomerId: true })}
        withCloseButton={false}
        position="left"
        closeOnClickOutside={true}

        title={
          <Group noWrap spacing='xs'>
            <ActionIcon
              size='lg'
              variant="light"
              radius='xl'
              color="blue"
              onClick={() => closeDrawer({ cleanURICustomerId: true })}
            >
              <IconArrowLeft size='1.25rem' stroke={1.5} />
            </ActionIcon>

            <Text>Klaim Garansi</Text>
          </Group>
        }
        size='md'

        styles={() => ({
          title: {
            fontWeight: 'bold',
            textTransform: 'uppercase'
          }
        })}
      >
        {!data.dataInitLoading && data.dataFlag === true &&
          <Box py='md' mb='2rem' sx={{ minHeight: '500px' }}>
            <Text size="sm">
              <LabelContentInline
                stateColLabel={4}
                stateLabel='Supplier'
                stateContent={
                  <Box>
                    <Text>{safeValue(data.data.supplier_name, '-')}</Text>
                    <Text>{safeValue(data.data.supplier_address, '-')}</Text>
                    <Text>{safeValue(data.data.supplier_contact, '-')}</Text>
                  </Box>
                }
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel='Tanggal Pembelian'
                stateContent={sqlDateToHumanDate({
                  stateDate: data.data.stock_tanggal_beli,
                  stateWithTime: false,
                  stateLang: 'id',
                  stateIsShort: false,
                  stateDay: false,
                  stateDefaultValue: ' - ',
                  stateDateType: 'day'
                })}
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel='Harga Beli'
                stateContent={'Rp ' + numberFormatter({ stateValue: data.data.stock_harga_beli })}
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel='Harga Jual'
                stateContent={'Rp ' + numberFormatter({ stateValue: data.data.stock_harga_jual })}
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel="Garansi"
                stateContent={
                  <Box>
                    <Text
                      mb='sm'
                      color={masaGaransiUtils__2({
                        stateGaransiType: data.data.stock_masa_garansi_type,
                        stateCanBeClaimed: data.data.can_be_claimed,
                        stateColorCanBeClaimed: '',
                        stateColorCannotBeClaimed: ''
                      }).colorCanBeClaimed}
                    >
                      {masaGaransiUtils__2({
                        stateGaransiType: data.data.stock_masa_garansi_type,
                        stateCanBeClaimed: data.data.can_be_claimed,
                      }).isCanBeClaimedCaption}
                    </Text>

                    <Text>
                      {masaGaransiUtils__1({
                        stateGaransiType: data.data.stock_masa_garansi_type,
                        stateGaransiBulan: data.data.stock_masa_garansi_bulan,
                        stateGaransiHari: data.data.stock_masa_garansi_hari,
                        stateTanggalPembelian: data.data.stock_tanggal_beli,
                        stateShowTanggalPembelian: true,
                      })}
                    </Text>
                  </Box>
                }
                stateDivider={true}
              />

              <LabelContentInline
                stateColLabel={4}
                stateLabel='Pengajuan Klaim'
                stateContent={
                  <Box>
                    <Text color="dimmed">Pengajuan ini bersumber dari :</Text>
                    <Text tt='uppercase' mb='xs'>
                      {getObjectParam2(utils.garansiReference, data.data.stock_garansi_reference, 'caption', '-')}
                    </Text>

                    <Text>
                      No Nota : {stringDivider(data.data.stock_garansi_project_id, [4, 6, 8], '.', '[Nomor Nota]')}
                    </Text>

                    <Text>
                      Client : {data.data.customer_name} {canAccessSeeCustomersPhoneNumber({ stateObject: { subLevel: loginContext } }) ? safeValue(data.data.customer_contact, '') : ''}
                    </Text>

                    <Text mt='md' color="dimmed">Diajukan oleh :</Text>
                    <Text>
                      {data.data.stock_garansi_pengaju_user_name} ({getPropInSubLevelRole(data.data.stock_garansi_pengaju_user_sub_level, 'caption', '-')})
                    </Text>

                    <Text>
                      {sqlDateToHumanDate({
                        stateDate: data.data.stock_garansi_tanggal_pengajuan,
                        stateWithTime: false,
                        stateLang: 'id',
                        stateIsShort: false,
                        stateDay: false,
                        stateDefaultValue: ' - ',
                        stateDateType: 'day'
                      })}
                    </Text>

                    <Text mt='md' color="dimmed">Keterangan :</Text>
                    <Text>{safeValue(data.data.stock_garansi_info, '-')}</Text>
                  </Box>
                }
                stateDivider={true}
              />
            </Text>

            <Box mt='2.5rem'>
              <Text fw='bold' tt='uppercase'>
                Item {Array.isArray(data.data.garansi_detil) ? `(${data.data.garansi_detil.length} Item)` : ''}
              </Text>

              {Array.isArray(data.data.garansi_detil) && (data.data.garansi_detil.length > 0) && Object.keys(data.data.garansi_detil).map((keyGD, indexGD) => {
                return (
                  <Box
                    key={keyGD}

                    mt='1rem'
                    mb='1rem'
                    p='xs'

                    sx={(tema) => ({
                      backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[0] : tema.colors.dark[6],
                      borderRadius: tema.radius.sm,
                      borderWidth: '1px',
                      borderStyle: 'solid',
                      borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                    })}
                  >
                    <Text size='sm'>
                      {`ITEM ${Number(indexGD) + 1} : ${safeValue(data.data.stock_category_name, '-')} ${safeValue(data.data.stock_category_sub_name, '-')} ${safeValue(data.data.garansi_detil[keyGD].stock_serial_number, '')}`}
                    </Text>

                    <Divider my='xs' />

                    <Box mt='sm'>
                      <Text color="dimmed" size='sm' fw={500}>
                        Foto Kondisi Item Sebelum Diklaim {garansiFotoByFlag({
                          stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                          stateFlagDB: 'stock_garansi_foto_flag',
                          stateFlagUtils: utils.statusItemGaransiFoto.sebelum_dikirim_supplier.value
                        }).length > 0 ? `(${garansiFotoByFlag({
                          stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                          stateFlagDB: 'stock_garansi_foto_flag',
                          stateFlagUtils: utils.statusItemGaransiFoto.sebelum_dikirim_supplier.value
                        }).length})` : ''}
                      </Text>

                      <Box mt='sm'>
                        <GaransiFotoComponent
                          stateData={{
                            dataFoto: garansiFotoByFlag({
                              stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                              stateFlagDB: 'stock_garansi_foto_flag',
                              stateFlagUtils: utils.statusItemGaransiFoto.sebelum_dikirim_supplier.value
                            }),
                            garansiItemStatus: utils.statusItemGaransi.pengajuan_klaim_garansi.value
                          }}

                          stateWithDeletePhoto={false}
                          fnClickPhoto={fnClickPhoto}
                          fnOnChanged={(dataArray) => { }}
                        />
                      </Box>
                    </Box>

                    {/* batas */}

                    <Box mt='2rem'>
                      <Text color="dimmed" size='sm' fw={500}>
                        Foto Kondisi Item Setelah Diklaim {garansiFotoByFlag({
                          stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                          stateFlagDB: 'stock_garansi_foto_flag',
                          stateFlagUtils: utils.statusItemGaransiFoto.setelah_dikirim_supplier.value
                        }).length > 0 ? `(${garansiFotoByFlag({
                          stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                          stateFlagDB: 'stock_garansi_foto_flag',
                          stateFlagUtils: utils.statusItemGaransiFoto.setelah_dikirim_supplier.value
                        }).length})` : ''}
                      </Text>

                      <Box mt='sm'>
                        <GaransiFotoComponent
                          stateData={{
                            dataFoto: garansiFotoByFlag({
                              stateDataArray: data.data.garansi_detil[keyGD].garansi_photos,
                              stateFlagDB: 'stock_garansi_foto_flag',
                              stateFlagUtils: utils.statusItemGaransiFoto.setelah_dikirim_supplier.value
                            }),
                            garansiItemStatus: utils.statusItemGaransi.sudah_dikirim_ke_supplier.value
                          }}

                          stateWithDeletePhoto={false}
                          fnClickPhoto={fnClickPhoto}
                          fnOnChanged={(dataArray) => { }}
                        />
                      </Box>
                    </Box>

                    {/* batas */}

                    {[utils.garansiReference.project_pengerjaan.value, utils.garansiReference.project_pengerjaan_history.value].includes(data.data.stock_garansi_reference) &&
                      <Box mt='lg'>
                        <Text size='sm'>
                          {`Item ini ditagged untuk ${data.data.customer_name ? data.data.customer_name : ' - '}`}
                        </Text>

                        <Text size='sm'>
                          {`Item ini ditagged untuk project (nota) ${stringDivider(data.data.stock_garansi_project_id, [4, 6, 8], '.', ' - ')}`}
                        </Text>
                      </Box>
                    }

                    <Box mt='1rem'>
                      <Text size='sm'>
                        Serial Number : {safeValue(
                          getValueFromItemsByDetilId({
                            stateDataArray: data.dataSerialNumber,
                            stateDetilId: data.data.garansi_detil[keyGD].stock_garansi_detil_id,
                            statePropRes: 'serialNumber'
                          }),
                          ' - '
                        )}
                      </Text>
                    </Box>

                    <Box mt='lg'>
                      <Text size='sm'>
                        Tanggal Pengajuan : {sqlDateToHumanDate({
                          stateDate: data.data.stock_garansi_tanggal_pengajuan,
                          stateWithTime: false,
                          stateLang: 'id',
                          stateIsShort: false,
                          stateDay: false,
                          stateDefaultValue: ' - ',
                          stateDateType: 'day'
                        })}
                      </Text>

                      <Text size='sm'>
                        Tanggal Kirim Ke Supplier : {sqlDateToHumanDate({
                          stateDate: data.data.garansi_detil[keyGD].tanggal_kirim_ke_supplier,
                          stateWithTime: false,
                          stateLang: 'id',
                          stateIsShort: false,
                          stateDay: false,
                          stateDefaultValue: ' - ',
                          stateDateType: 'day'
                        })}
                      </Text>

                      <Text size='sm' mb='sm'>
                        Tanggal Terima Dari Supplier : {sqlDateToHumanDate({
                          stateDate: data.data.garansi_detil[keyGD].tanggal_tiba_dari_supplier,
                          stateWithTime: false,
                          stateLang: 'id',
                          stateIsShort: false,
                          stateDay: false,
                          stateDefaultValue: ' - ',
                          stateDateType: 'day'
                        })}
                      </Text>

                      <Text size='sm'>
                        Hasil Klaim Dari Supplier : {getObjectParam2(utils.statusItemGaransi, safeValue(
                          getValueFromItemsByDetilId({
                            stateDataArray: data.dataSerialNumber,
                            stateDetilId: data.data.garansi_detil[keyGD].stock_garansi_detil_id,
                            statePropRes: 'positioning'
                          }),
                          ''
                        ), 'caption', ' - ')}
                      </Text>
                    </Box>
                  </Box>
                )
              })}
            </Box>
          </Box>
        }

        {!data.dataInitLoading && data.dataFlag === false &&
          <Box py='md' mb='2rem' sx={{ minHeight: '500px' }}>
            <Paper px="md" py='xl'>
              <Text ta='center' size='sm'>Data tidak ditemukan</Text>
            </Paper>
          </Box>
        }

        {data.dataInitLoading &&
          <Box py='md' mb='2rem' sx={{ minHeight: '500px' }}>
            <Paper px="md" py='xl'>
              <Text ta='center' size='sm'>Loading Data..</Text>
            </Paper>
          </Box>
        }
      </Drawer>

      <ModalResponse
        stateShow={data.modalResponse.show}
        fnHide={() => setData(d => ({
          ...d,
          modalResponse: {
            ...d.modalResponse,
            show: false
          }
        }))}

        stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
        stateType={data.modalResponse.type}
        stateContent={data.modalResponse.content}
      />
    </React.Fragment>
  )
}

export default React.memo(GaransiHistorySelected);